import * as actionTypes from './actionTypes';
import { CompanyActionTypes } from './actionTypes';
import { HttpError } from '../../config/Axios/axios-instance';

export type UserCompanyRoleStateType = {
  confirmUserCompanyRoleLoading: boolean;
  confirmUserCompanyRoleSuccess: boolean;
  confirmUserCompanyRoleError: HttpError;
  declineUserCompanyRoleLoading: boolean;
  declineUserCompanyRoleSuccess: boolean;
  declineUserCompanyRoleError: HttpError;
};

export type UserCompanyRoleActionType = UserCompanyRoleStateType & {
  type: CompanyActionTypes;
};

export const initialState: UserCompanyRoleStateType = {
  confirmUserCompanyRoleLoading: false,
  confirmUserCompanyRoleSuccess: false,
  confirmUserCompanyRoleError: null,
  declineUserCompanyRoleLoading: false,
  declineUserCompanyRoleSuccess: false,
  declineUserCompanyRoleError: null,
};

const confirmUserCompanyRoleStart = (
  state: UserCompanyRoleStateType,
): UserCompanyRoleStateType => ({
  ...state,
  confirmUserCompanyRoleLoading: true,
});

const confirmUserCompanyRoleSuccess = (
  state: UserCompanyRoleStateType,
): UserCompanyRoleStateType => ({
  ...state,
  confirmUserCompanyRoleLoading: false,
  confirmUserCompanyRoleSuccess: true,
  confirmUserCompanyRoleError: null,
});

const confirmUserCompanyRoleFail = (
  state: UserCompanyRoleStateType,
  action: UserCompanyRoleActionType,
): UserCompanyRoleStateType => ({
  ...state,
  confirmUserCompanyRoleError: action.confirmUserCompanyRoleError,
  confirmUserCompanyRoleLoading: false,
});

const declineUserCompanyRoleStart = (
  state: UserCompanyRoleStateType,
): UserCompanyRoleStateType => ({
  ...state,
  declineUserCompanyRoleLoading: true,
});

const declineUserCompanyRoleSuccess = (
  state: UserCompanyRoleStateType,
): UserCompanyRoleStateType => ({
  ...state,
  declineUserCompanyRoleLoading: false,
  declineUserCompanyRoleSuccess: true,
  declineUserCompanyRoleError: null,
});

const declineUserCompanyRoleFail = (
  state: UserCompanyRoleStateType,
  action: UserCompanyRoleActionType,
): UserCompanyRoleStateType => ({
  ...state,
  declineUserCompanyRoleError: action.declineUserCompanyRoleError,
  declineUserCompanyRoleLoading: false,
});

const reducer = (state = initialState, action: UserCompanyRoleActionType) => {
  switch (action.type) {
    case actionTypes.CONFIRM_USER_COMPANY_ROLE_START:
      return confirmUserCompanyRoleStart(state);
    case actionTypes.CONFIRM_USER_COMPANY_ROLE_SUCCESS:
      return confirmUserCompanyRoleSuccess(state);
    case actionTypes.CONFIRM_USER_COMPANY_ROLE_FAIL:
      return confirmUserCompanyRoleFail(state, action);
    case actionTypes.CONFIRM_USER_COMPANY_ROLE_START:
      return declineUserCompanyRoleStart(state);
    case actionTypes.CONFIRM_USER_COMPANY_ROLE_SUCCESS:
      return declineUserCompanyRoleSuccess(state);
    case actionTypes.CONFIRM_USER_COMPANY_ROLE_FAIL:
      return declineUserCompanyRoleFail(state, action);
    default:
      return state;
  }
};

export default reducer;
